import { Link } from "react-router-dom";
import { BadgeCheck, MapPin, Briefcase } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { RatingSummary } from "@/components/Stars";

export const ProviderLogo = ({ provider, size = "h-14 w-14" }) =>
  provider?.logo_path ? (
    <img src={fileUrl(provider.logo_path)} alt={provider.business_name} className={`${size} rounded-xl object-cover`} />
  ) : (
    <div className={`${size} flex items-center justify-center rounded-xl bg-teal-50 font-bold text-teal-700`}>
      {(provider?.business_name || "?").slice(0, 2).toUpperCase()}
    </div>
  );

export const VerifiedBadge = ({ testId = "verified-badge" }) => (
  <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full bg-teal-50 px-2.5 py-0.5 text-xs font-semibold text-teal-800">
    <BadgeCheck className="h-3.5 w-3.5" /> Terverifikasi
  </span>
);

export const ProviderCard = ({ provider }) => {
  const cover = provider.portfolio?.[0];
  return (
    <Link
      to={`/penyedia/${provider.slug}`}
      data-testid={`provider-card-${provider.slug}`}
      className="card-soft card-lift group flex flex-col overflow-hidden"
    >
      <div className="relative h-36 bg-stone-100">
        {cover && <img src={fileUrl(cover)} alt="" className="h-full w-full object-cover" loading="lazy" />}
        <div className="absolute -bottom-6 left-5 rounded-2xl bg-white p-1 shadow-sm">
          <ProviderLogo provider={provider} size="h-12 w-12" />
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5 pt-9">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="text-base font-bold text-stone-900 group-hover:text-teal-800">{provider.business_name}</h3>
          {provider.verified && <VerifiedBadge testId={`verified-badge-${provider.slug}`} />}
        </div>
        <RatingSummary rating={provider.rating} count={provider.review_count} testId={`provider-rating-${provider.slug}`} />
        <p className="line-clamp-2 text-sm leading-relaxed text-stone-500">{provider.description}</p>
        <div className="mt-auto flex flex-col gap-1.5 text-xs text-stone-500">
          <span className="flex items-center gap-1.5">
            <Briefcase className="h-3.5 w-3.5" />
            {provider.subcategory_items.map((s) => s.name).join(", ")}
          </span>
          <span className="flex items-center gap-1.5">
            <MapPin className="h-3.5 w-3.5" />
            {provider.city_items.map((c) => c.name).join(", ")}
          </span>
        </div>
      </div>
    </Link>
  );
};
